export type AppliedPromotionalCode = {
    contractPromotionId?: string
    code: string
    fullCode: string
    description: string
}

export function getForInput(codes: AppliedPromotionalCode[]): {
    contractPromotionId?: string
    code: string
    fullCode: string
}[] {
    return codes.map(code => {
        return {
            contractPromotionId: code.contractPromotionId,
            code: code.code,
            fullCode: code.fullCode
        }
    })
}
